export const CLUB_STATE_TOKEN = 'MEMBERSHIP';

export const CLUB_API_PATHS = {
    cancel_reasons: 'client/cancel_membership_reasons',
    cancel_membership: 'client/cancel_membership',
    claim_deal: 'shared/tasks'

};
